import { styled } from '@mui/material';
import { Download } from '@mui/icons-material';
import { Button, CircularProgress, Tooltip } from '@mui/material';
import FlexBetween from 'components/flexbox/FlexBetween';
import SearchInput from 'components/input-fields/SearchInput';
import axiosInstance from 'utils/axios';
import * as FileSaver from 'file-saver';
const SecondaryWrapper = styled(FlexBetween)(({ theme }) => ({
    gap: 8,
    flexWrap: 'wrap',
    margin: '24px 0',
    [theme.breakpoints.down(550)]: {
        '& .MuiInputBase-root': {
            maxWidth: 'calc(100% - 90px)',
        },
    },
}));

const SearchArea = ({
    value,
    onChange,
    setValue,
    status,
    isDownloading,
    onDownloadStart,
    onDownloadEnd,
}) => {
    const handleChange = (e) => {
        const v = e && e.target ? e.target.value : e;
        if (setValue) setValue(v);
        if (onChange) onChange(v);
    };

    const handleExport = async () => {
        try {
            if (onDownloadStart) onDownloadStart();
            const res = await axiosInstance.get('/api/prv/invoices/download', {
                params: {
                    status: status || 'all',
                    packageTypes: ['main', 'additional'],
                },
                responseType: 'blob',
            });

            const blob = new Blob([res.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            const contentDisposition = res?.headers?.['content-disposition'];
            const filenameMatch =
                typeof contentDisposition === 'string'
                    ? contentDisposition.match(/filename="?([^"]+)"?/)
                    : null;
            const filename = filenameMatch?.[1] || 'Data Invoice.xlsx';
            FileSaver.saveAs(blob, filename);
        } catch (err) {
            const maybeBlob = err?.response?.data;
            if (maybeBlob instanceof Blob) {
                try {
                    const text = await maybeBlob.text();
                    console.error('Invoice export error:', text);
                    alert(text);
                } catch (readErr) {
                    console.error('Invoice export error:', err);
                }
            } else {
                console.error('Invoice export error:', err);
            }
        } finally {
            if (onDownloadEnd) onDownloadEnd();
        }
    };

    return (
        <SecondaryWrapper>
            <SearchInput
                placeholder="Search..."
                value={value || ''}
                onChange={handleChange}
            />
            <Tooltip title="Download Data">
                <Button
                    variant="contained"
                    onClick={handleExport}
                    color="primary"
                    style={{ cursor: 'pointer', fontSize: 14 }}
                    disabled={Boolean(isDownloading)}
                    endIcon={
                        isDownloading ? (
                            <CircularProgress size={18} color="inherit" />
                        ) : (
                            <Download />
                        )
                    }
                >
                    Download Data
                </Button>
            </Tooltip>
        </SecondaryWrapper>
    );
};

export default SearchArea;
